import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "./Admin.css";
import api, { BACK_END_API, API_ENDPOINTS } from "../config";
const AdminDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("All");
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [selectedOrder, setSelectedOrder] = useState(null);

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: "", message: "" }), 5000);
  };
  useEffect(() => {
    api
      .get(API_ENDPOINTS.GET_ALL_ORDERS, { withCredentials: true })
      .then((response) => {
        const sorted = response.data.orders.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setOrders(sorted);
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
        setError("Failed to fetch orders. Please try again.");
        window.location.href = "/login";
      });
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    try {
      await api.put(`${API_ENDPOINTS.UPDATE_ORDERS}/${id}`, {
        status: newStatus,
      });

      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order._id === id ? { ...order, status: newStatus } : order
        )
      );

      showNotification("success", "Status Changed successfully ✅");
    } catch (err) {
      console.error("Failed to update status:", err);
      showNotification("error", "Failed to Change Status ❌");
    }
  };

  const [verifying, setVerifying] = useState(null);

const handleVerifyPayment = async (orderId) => {
  setVerifying(orderId);
  try {
    const response = await api.post(`${API_ENDPOINTS.VERIFY_PAYMENT}/${orderId}`, {}, { withCredentials: true });
    
    if (response.data.success) {
      // Update the order's paymentStatus in local state immediately
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order._id === orderId ? { ...order, paymentStatus: "Paid" } : order
        )
      );
      showNotification("success", response.data.message || "Payment verified ✅");
    } else {
      showNotification("error", response.data.message || "Payment not verified ❌");
    }
    console.log("verif this",response.data)
  } catch (err) {
    console.error(err);
    showNotification("error", "Failed to verify payment ❌");
  }
  setVerifying(null);
};


  const filteredOrders =
    filter === "All"
      ? orders
      : orders.filter((order) => (order.status || "Pending") === filter);

  if (error) return <div className="dashboard-content">{error}</div>;
  return (
    <div className="admin-container">
      <Sidebar />

      <div className="dashboard-content">
        {notification.message && (
          <div className={`ik-notification ${notification.type}`}>
            <span>{notification.message}</span>
            <button
              className="ik-close-btn"
              onClick={() => setNotification({ type: "", message: "" })}
            >
              ✖
            </button>
          </div>
        )}

        <h2>Order List</h2>

        <div className="filter-container">
          <label htmlFor="filter">Filter Orders: </label>
          <select
            id="filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Pending">Pending</option>
            <option value="Processing">Processing</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        <table className="orders-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Email</th>
              <th>Phone No</th>
              <th>Status</th>
              <th>Details</th>
              <th>Receipt</th>
              <th>Verified</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map((order) => (
              <tr key={order._id}>
                <td>{order.customerName}</td>
                <td>{order.email}</td>
                <td>{order.phoneNumber}</td>
                <td>
                  <select
                    value={order.status || "Pending"}
                    onChange={(e) =>
                      handleStatusChange(order._id, e.target.value)
                    }
                  >
                    <option>Pending</option>
                    <option>Processing</option>
                    <option>Completed</option>
                    <option>Cancelled</option>
                  </select>
                </td>
                <td>
                  <button className="Detail-btn"onClick={() => setSelectedOrder(order)}>
                   <span className="button-content">View Details</span>
                  </button>
                </td>
                <td>
  {order.receiptUrl ? (
    <a
      href={`${BACK_END_API}${order.receiptUrl}`}
      target="_blank"
      rel="noopener noreferrer"
    >
<label class="custum-file-upload" for="file">
<div class="icon">
<svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24"><g stroke-width="0" id="SVGRepo_bgCarrier"></g><g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <path fill="" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z" clip-rule="evenodd" fill-rule="evenodd"></path> </g></svg>
</div>
<div class="text">
   <span>Click to See the Receipt</span>
   </div>
</label>

    </a>
  ) : (
    "No Receipt"
  )}

</td>
                <td>
  <button
    className={`verify-btn ${
      order.paymentStatus === "Paid" ? "paid" : "unpaid"
    }`}
    disabled={order.paymentStatus === "Paid" || verifying === order._id}
    onClick={() =>
      order.paymentStatus !== "Paid" && handleVerifyPayment(order._id)
    }
  >
    {verifying === order._id
      ? "Verifying..."
      : order.paymentStatus === "Paid"
      ? "Paid"
      : "Verify Payment"}
  </button>
</td>

              </tr>
            ))}
          </tbody>
        </table>

        {filteredOrders.length === 0 && (
          <p style={{ marginTop: "15px" }}>No orders found for this filter.</p>
        )}

        {selectedOrder && (
          <div className="modal-overlay" onClick={() => setSelectedOrder(null)}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Order Details</h3>
              <p>
                <b>Service:</b> {selectedOrder.service}
              </p>
              <p>
                <b>Package:</b> {selectedOrder.packageName}
              </p>
              <p>
                <b>DOB:</b>{" "}
                {new Date(selectedOrder.date_of_birth).toLocaleDateString()}
              </p>
              <p>
                <b>Total Amount:</b> {selectedOrder.totalAmount} Birr
              </p>
              <p>
                <b>Features:</b>
              </p>
              <ul>
                {Object.entries(selectedOrder.packageDetails.features).map(
                  ([featureName, featureData], i) =>
                    featureData.enabled && (
                      <li key={i}>
                        {featureName} – {featureData.price} Birr
                      </li>
                    )
                )}
              </ul>
              <button onClick={() => setSelectedOrder(null)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
